import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Ana Sayfa', href: '/' },
  { label: 'Hakkımızda', href: '/hakkimizda' },
  { label: 'Hizmetler', href: '/hizmetler' },
  { label: 'Referanslar', href: '/referanslar' },
  { label: 'SSS', href: '/sss' },
  { label: 'İletişim', href: '/iletisim' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 80);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  const transparent = isHome && !scrolled;

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${transparent ? 'bg-transparent' : 'bg-[#0f1923] border-b border-white/10'}`}>
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between" style={{ height: 76 }}>

        {/* Logo */}
        <Link to="/" className="flex items-center">
          <span className="text-xl md:text-2xl font-extrabold tracking-tight leading-none text-white">İzmir'de <span style={{ color: '#d4a853' }}>Tenteci</span></span>
        </Link>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-7">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`font-body text-sm font-medium tracking-wide transition-all whitespace-nowrap ${
                location.pathname === link.href
                  ? 'text-[#d4a853]'
                  : transparent
                  ? 'text-white/75 hover:text-white'
                  : 'text-white/65 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-3">
          <a
            href="https://wa.me/905362771709"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="font-body text-sm font-medium px-4 py-2 rounded-lg border border-white/20 text-white/70 hover:border-[#d4a853] hover:text-[#d4a853] transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line mr-1.5"></i>WhatsApp
          </a>
          <a
            href="tel:05362771709"
            className="font-body bg-[#d4a853] text-[#0f1923] text-sm font-semibold px-5 py-2.5 rounded-lg hover:bg-[#e8c47a] transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill mr-1.5"></i>Hemen Ara
          </a>
        </div>

        {/* Hamburger */}
        <button
          className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer ${transparent ? 'text-white' : 'text-white'}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menü"
        >
          <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-3-line'}`}></i>
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0f1923] border-t border-white/10 px-6 py-5 flex flex-col gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`font-body text-sm font-medium py-3 px-3 rounded-lg transition-colors ${
                location.pathname === link.href ? 'text-[#d4a853] bg-white/5' : 'text-white/70 hover:text-white hover:bg-white/5'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="flex flex-col gap-2 mt-3 pt-3 border-t border-white/10">
            <a href="tel:05362771709" className="flex items-center justify-center gap-2 bg-[#d4a853] text-[#0f1923] font-body text-sm font-semibold px-5 py-3 rounded-lg cursor-pointer whitespace-nowrap">
              <i className="ri-phone-fill"></i>Hemen Ara
            </a>
            <a href="https://wa.me/905362771709" target="_blank" rel="noopener noreferrer nofollow" className="flex items-center justify-center gap-2 border border-white/20 text-white/70 font-body text-sm font-semibold px-5 py-3 rounded-lg cursor-pointer whitespace-nowrap">
              <i className="ri-whatsapp-line"></i>WhatsApp&apos;tan Yaz
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
